import React from 'react'

import { checkStrength } from '../../../util/validators'

class BaseForm extends React.Component {
  // eslint-disable-line react/require-render-return
  constructor(props) {
    super(props)
    this.inputs = {}
    this.state = {
      isSubmitting: false,
      showGenericError: false,
      validators: {},
      fields: {},
    }
  }

  onFieldChange = (event, field, validator, msg, pristine = false) => {
    const { value } = event.target
    const valid = value && typeof validator === 'function' ? validator(value) : !!value
    this.updateField(field, value, valid, pristine, msg, undefined)
  }

  getInvalidFields = () => {
    const { fields } = this.state
    const invalidFields = {}
    Object.keys(fields).forEach(key => {
      if (!fields[key].valid) invalidFields[`invalid_${key}`] = true
    })
    return invalidFields
  }

  getErrorMessage = (value, message) => (typeof message === 'function' ? message(value) : message)

  getPasswordErrorMessage = value => {
    const { message } = checkStrength(value)
    return message
  }

  isValidPassword = (value, level) => {
    const { strength } = level ? { strength: level } : checkStrength(value)
    return strength > 2
  }

  updateField = (field, value, valid, pristine, message, callback) => {
    const fields = { ...this.state.fields }
    const newField = { ...fields[field], value }

    newField.valid = false
    if (typeof valid === 'boolean') {
      newField.valid = valid
    }

    newField.pristine = true
    if (typeof pristine === 'boolean') {
      newField.pristine = pristine
    }

    newField.msg = ''
    if (typeof message === 'string') {
      newField.msg = message
    }

    this.setState(
      {
        fields: {
          ...fields,
          [field]: newField,
        },
      },
      callback
    )
  }

  checkSomeFieldsIsValid = fieldsToCheck =>
    new Promise((resolve, reject) => {
      let allValid = true
      const updatedFields = this.state.fields
      fieldsToCheck
        .filter(key => !this.state.fields[key].valid)
        .forEach(key => {
          updatedFields[key].pristine = false
          allValid = false
        })
      if (allValid) {
        resolve()
      } else {
        this.setState({ fields: updatedFields, isSubmitting: false }, reject)
      }
    })

  checkFormIsValid = () =>
    new Promise((resolve, reject) => {
      let allValid = true
      const updatedFields = this.state.fields
      Object.keys(this.state.fields).forEach(key => {
        if (!this.state.fields[key].valid) {
          updatedFields[key].pristine = false
          allValid = false
        }
      })
      if (allValid) {
        resolve()
      } else {
        this.setState({ fields: updatedFields, isSubmitting: false }, reject)
      }
    })

  updateFocus = input => {
    // FIXME(rlopes) this is not working
    if (this.inputs && this.inputs[input] && this.inputs[input].focus) {
      this.inputs[input].focus()
    }
  }

  validateSomeFieldsBeforeSend = fieldsToValidate =>
    new Promise(resolve => {
      const { fields, validators } = { ...this.state }
      const { action, message } = validators[fieldsToValidate]
      const field = fields[fieldsToValidate]
      const { value } = field
      fields[fieldsToValidate] = {
        ...field,
        msg: this.getErrorMessage(value, message),
        valid: value && typeof action === 'function' ? action(value) : !!value,
        pristine: false,
      }
      this.setState({ fields }, resolve)
    })

  validateBeforeSend = () =>
    new Promise(resolve => {
      const { fields, validators } = { ...this.state }
      Object.keys(fields).forEach(currentField => {
        const { action, message } = validators[currentField]
        const field = fields[currentField]
        const { value } = field
        fields[currentField] = {
          ...field,
          msg: this.getErrorMessage(value, message),
          valid: value && typeof action === 'function' ? action(value) : !!value,
          pristine: false,
        }
      })
      this.setState({ fields }, resolve)
    })

  render() {
    throw new Error('not implemented')
  }
}

export default BaseForm
